export const iconFontAwesomeHumanitarianVirus = (
	<i className="fa-solid fa-virus"></i>
);
